import React from "react";
import logoImg from "../../assets/logo/logo-hd.png";

const ICPPageLoader = () => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      backgroundColor: "#fff",
      zIndex: 1300,
      gap: 16,
    }}
  >
    <div
      className="logo-loader"
      style={{
        width: 80,
        height: 80,
        backgroundImage: `url(${logoImg})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
      role="img"
      aria-label="Loading"
    />
  </div>
);

export default ICPPageLoader;
